export const MAX_LOGIN_POLL_INTERVAL_MS = 2500;
export const MAX_HYBRID_FLAG_TIMEOUT_MS = 3000;

const PASS_THROUGH_STATUSES = new Set([
  "pending",
  "expired",
  "unknown",
  "unfinished",
  "disabled",
  "closed",
]);

const EXCHANGE_CODE_RE = /^[A-Za-z0-9_-]+$/;

/**
 * HTTP-результат poll входа через MAX → вид экрана.
 * Сбой poll (сеть, 429, 5xx) — retry: экран ожидания не меняется (D-150).
 * 404 и 400 — closed: попытки нет или вход через MAX выключен.
 */
export function mapMaxLoginStatus({ httpStatus, data, networkError } = {}) {
  if (networkError) {
    return { kind: "retry" };
  }

  if (httpStatus === 404 || httpStatus === 400) {
    return { kind: "closed" };
  }

  if (
    httpStatus === 429 ||
    (typeof httpStatus === "number" && httpStatus >= 500)
  ) {
    return { kind: "retry" };
  }

  if (httpStatus != null && httpStatus !== 200) {
    return { kind: "retry" };
  }

  const loginStatus = data && data.login_status;

  if (loginStatus === "authenticated") {
    if (!data.token || !data.user) {
      return { kind: "retry" };
    }
    return {
      kind: "session",
      session: { token: data.token, user: data.user },
    };
  }

  if (loginStatus === "banned") {
    const mapped = { kind: "banned" };
    if (data.detail != null) {
      mapped.detail = data.detail;
    }
    return mapped;
  }

  if (PASS_THROUGH_STATUSES.has(loginStatus)) {
    return { kind: loginStatus };
  }

  return { kind: "retry" };
}

export function isValidExchangeCode(code) {
  if (typeof code !== "string") {
    return false;
  }
  if (code.length < 20 || code.length > 64) {
    return false;
  }
  return EXCHANGE_CODE_RE.test(code);
}
